import { IStyle } from 'Styles';
import React, { ReactNode } from 'react';

interface Props {
  leftHeaderComponent?: ReactNode;
  rightHeaderComponent?: ReactNode;
  headingContainerStyle?: React.CSSProperties;
  children: ReactNode;
  containerStyle?: React.CSSProperties;
}

const SectionContainer = (props: Props) => {
  const {
    leftHeaderComponent,
    rightHeaderComponent,
    children,
    containerStyle,
    headingContainerStyle,
  } = props;

  return (
    <div id="sectioncontainer" style={{ ...styles.root, ...containerStyle }}>
      <div
        id="sectioncontainer-header-wrapper"
        style={{ ...headingContainerStyle, ...styles.headingContainer }}
      >
        {leftHeaderComponent}
        {rightHeaderComponent}
      </div>
      {children}
    </div>
  );
};

const styles: IStyle = {
  root: {
    margin: 10,
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
  },
  headingContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    flex: 1,
  },
};

export default SectionContainer;
